import { GET } from '../utils/httpMethods';

const setSimulationSummary = (simulationSummary) => ({
    type: 'SET_SIMULATION_SUMMARY',
    simulationSummary,
});

const setErrorSimulationSummary = (errorSimulationSummary) => ({
    type: 'SET_ERROR_SIMULATION_SUMMARY',
    errorSimulationSummary,
});

export const resetSimulationSummary = () => ({
    type: 'RESET_SIMULATION_SUMMARY',
});

export const getSimulationSummary = (id) => async (dispatch) => {
    dispatch({ type: 'SET_SIMULATION_SUMMARY_LOADING' });

    try {
        const response = await GET(`/api/simulations/${id}/summary`);
        dispatch(setSimulationSummary(await response.json()));
    } catch (error) {
        dispatch(setErrorSimulationSummary(true));
    }
};
